import AbstractEntryCommand from "./AbstractEntryCommand.js";
import getNamedCommandHeading from "../getNamedCommandHeading.js";
import selection from "../selection.js";

/**
 * `moveCommand` is the command used to move entries through the file hierarchy.
 * `moveCommand` is valid if the selection is not empty and contains only
 * entries this can be moved.
 *
 * `moveCommand` also stubs the tree of target according to the entries
 * to move in order to prevent to move a folder inside itself.
 */
export default class MoveCommand extends AbstractEntryCommand {
	constructor() {
		super(...arguments);

		this._destination = undefined;
	}

	getDestination() {
		return this._destination;
	}

	setDestination(newValue) {
		this._destination = newValue;
	}

	accept(aVisitor) {
		return aVisitor.visitMoveCommand(this);
	}

	requireRefresh() {
		return true;
	}

	priority() {
		return 600;
	}

	heading() {
		return getNamedCommandHeading("Actions");
	}

	_performOnService(callback) {
		this._documentService.executeMoveCommand(this, callback);
	}

	_execute() {
		const entries = selection.entries();
		const parent = entries[0].parent();
		parent.removeChildren(entries);
		this._destination.addChildren(entries);
	}

	static isApplicable() {
		return (
			selection.notEmpty() &&
			selection.every((each) => each.entry().canBeMoved())
		);
	}
}
